<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="text"
                  v-model="form.name"
                  label="Name"
                  :error-messages="[].concat(fieldErrors('form.name'))"
                  @blur="$v.form.name.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <client-select
                  :error-messages="[].concat(fieldErrors('form.clientId'))"
                  v-model="form.clientId"
                  label="Select Client"
                  @blur="$v.form.clientId.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="url"
                  v-model="form.url"
                  label="URL"
                  :error-messages="[].concat(fieldErrors('form.url'))"
                  @blur="$v.form.url.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="text"
                  v-model="form.username"
                  label="Username"
                  :error-messages="[].concat(fieldErrors('form.username'))"
                  @blur="$v.form.username.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="password"
                  v-model="form.password"
                  label="Password"
                  :error-messages="[].concat(fieldErrors('form.password'))"
                  @blur="$v.form.password.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <vault-folder-select
                  v-model="form.folderId"
                  label="Folder"
                  :error-messages="[].concat(fieldErrors('form.folderId'))"
                  @blur="$v.form.folderId.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.notes"
                  label="Notes"
                  :error-messages="[].concat(fieldErrors('form.notes'))"
                  @blur="$v.form.notes.$touch()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import ClientSelect from "src/components/ClientSelect.vue";
import VaultFolderSelect from "components/VaultFolderSelect.vue";
import formatterMixin from "@/mixins/formatterMixin";

const defaultInputs = {
  id: 0,
  clientId: 0,
  accountId: 0,
  name: "",
  url: "",
  username: "",
  password: "",
  notes: "",
  folderId: 0,
};

export default {
  components: {
    AlertMessage,
    ClientSelect,
    VaultFolderSelect,
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      id: {},
      clientId: { required },
      accountId: {},
      name: { required },
      url: {},
      username: { required },
      password: { required },
      notes: {},
      folderId: {},
    },
  },
  validationMessages: {
    form: {
      id: {},
      clientId: { required: "Required" },
      accountId: {},
      name: { required: "Required" },
      url: { required: "Required" },
      username: { required: "Required" },
      password: { required: "Required" },
      notes: { required: "Required" },
      folderId: { required: "Required" },
    },
  },

  data() {
    return {
      showDialog: this.show,
      form: {
        ...defaultInputs,
        clientId: this.clientId,
      },
      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        this.form = {
          ...newTask,
          clientId: this.clientId,
        };
      } else {
        this.form = {
          ...defaultInputs,
          clientId: this.clientId,
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      user: (state) => state.account.data.user,
      passwordVault: (state) => state.passwordVault,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return this.isEdit ? "Edit Password Vault" : "Add Password Vault";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    taskId() {
      return UTIL.gv(this.item, "id", "");
    },
  },

  methods: {
    ...mapActions("passwordVault", ["create", "update"]),

    initForm() {
      if (this.clientId) {
        this.form = {
          ...this.form,
        };
      }
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
      };

      if (this.isEdit) {
        await this.update({
          id: this.taskId,
          ...payload,
        });
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.passwordVault.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>
